(function () {
    "use strict";

    angular
        .module("app")
        .directive("columnTypeAhead", columnTypeAhead);

    function columnTypeAhead() {
        return {
            restrict: "E",
            link: function (scope) {
                scope.activateSearch = false;
                scope.setValue = function (item,e,a) {
                    if (item.visible) {
                        var grid = document.querySelector('.ag-body-viewport');
                        grid.scrollLeft = item.fromLeft - item.width;
                        scope.columnHidden = false;
                    } else {
                        scope.columnHidden = item.colName;
                    }
                };

                scope.$watch('selectedText', function (n) {
                    if (n == "") {
                        scope.columnHidden = false;
                    }
                });

                angular.element(document.querySelector('body')).on('keyup', function (e) {
                    if (e.ctrlKey && e.shiftKey && e.code == 'KeyF') {
                        scope.showColSeek = !scope.showColSeek;
                        scope.$evalAsync();
                        setTimeout(function () {
                            var t = angular.element(document.querySelector('.colFocus'));
                            t[0].focus();
                        }, 50);
                    }
                })

            },
            scope: { colData: "=" },
            template: '<span ng-show="showColSeek"><input' +
                ' uib-typeahead="item.colName for item in colData | filter: $viewValue"' +
                ' ng-model="selectedText"' +
                ' typeahead-template-url="colSeekTemplate.html"' +
                ' typeahead-on-select="setValue($item)"' +
                ' typahead-select-on-blur="true"' +
                ' class="form-control colFocus"' +
                ' aria-autocomplete="list"' +
                ' autocomplete="off"' +
                ' placeholder="Scroll to column..."' +
                ' type="text" reset-field />' +
                '<div ng-show="columnHidden"><div class="error-text" style="width:250px;">{{columnHidden}} is hidden. <br/>Use Column Configuration to unhide.</div></div></span>'
        };
    }
})();

